
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["chevron-right",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.432","height":"14.86"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.253 1.967l5.323 5.477-5.323 5.5.174.289 5.612-5.789-5.613-5.786z","fill":"#006db6","stroke":"#006db6","stroke-width":"2"}})])
          )
        }
      }
    